const map = {
	"./en-US/index": [
		4039,
		[
			39
		]
	],
	"./es-ES/index": [
		4352,
		[]
	],
	"./pt-BR/index": [
		3552,
		[
			552
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map((id) => (__webpack_require__.e(id)))).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6704;
module.exports = webpackAsyncContext;